export var EDITING_MODE = 'editing-mode';